import type { ApiError } from "./ApiError";

export type FormNamePath = Array<string | number>;

export interface FormFieldError {
  name: FormNamePath;
  errors: string[];
}

export const parseFieldPath = (path: string): FormNamePath =>
  path.split(".").map((part) => (/^\d+$/.test(part) ? Number(part) : part));

export const toFormFieldErrors = (error: ApiError): FormFieldError[] =>
  Object.entries(error.fields || {}).map(([path, messages]) => ({
    name: parseFieldPath(path),
    errors: messages,
  }));
